module.exports = __webpack_public_path__ + "img/icn_money-accent.770e3d83.svg";